import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { getCurrentInstance, watch } from 'vue'

import { useInstagramScenarioEditorStore } from '@/client/features/instagram_instantwin_prize/hooks/instagramScenarioEditorStore'
import { TrackingService } from '@/client/services'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepLottery',
  setup(__props) {

// @ts-nocheck TODO: 既存の型エラーを解消したら外す
const { proxy } = getCurrentInstance() as any

// Store
const store = useInstagramScenarioEditorStore()
const { lottery, errors } = storeToRefs(store)

const getFileExtension = (name: string): string => {
  const index = name.lastIndexOf('.')
  return index >= 0 ? name.slice(index).toLowerCase() : ''
}

const isSupportedImageExtension = (name: string): boolean => {
  return ['.jpg', '.jpeg', '.png'].includes(getFileExtension(name))
}

/**
 * メディアが画像かどうかを判定
 */
const isImageFile = (): boolean => {
  if (!lottery.value.url) {
    return false
  }
  // fileTypeプロパティがあれば優先的に使用（blob URLの場合）
  if (lottery.value.fileType) {
    return lottery.value.fileType === 'image'
  }
  // fileTypeがない場合はURLの拡張子で判定（サーバーからのURLの場合）
  const imageExtensions = ['.png', '.jpg', '.jpeg']
  const url = lottery.value.url.toLowerCase()
  return imageExtensions.some(ext => url.includes(ext)) || lottery.value.url.startsWith('data:image/')
}

/**
 * メディアファイル名を取得
 */
const getMediaFileName = (): string => {
  // fileNameフィールドがあればそれを優先
  if (lottery.value.fileName) {
    return lottery.value.fileName
  }

  // blob URLの場合は拡張子から生成
  if (lottery.value.url && lottery.value.url.startsWith('blob:')) {
    const fileType = lottery.value.fileType === 'image' ? 'png' : 'mp4'
    return `media.${fileType}`
  }
  // サーバーURLの場合はURLから抽出
  if (lottery.value.url) {
    const urlWithoutQuery = lottery.value.url.split('?')[0]
    const urlParts = urlWithoutQuery.split('/')
    const fileName = urlParts[urlParts.length - 1]

    return decodeURIComponent(fileName)
  }
  return '抽選中メディア'
}

/**
 * メディア選択ボタンのクリックハンドラ
 */
const handleMediaSelectClick = () => {
  const fileInput = document.getElementById('lotteryMediaFileInput') as HTMLInputElement
  if (fileInput) {
    fileInput.click()
  }
}

/**
 * メディアファイル変更ハンドラ
 */
const handleMediaFileChange = async (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]

  if (!file) {
    return
  }

  // ファイル形式チェック
  const imageTypes = ['image/png', 'image/jpeg']
  const videoTypes = ['video/mp4']

  const isImage = imageTypes.includes(file.type)
  const isVideo = videoTypes.includes(file.type)

  if (!isImage && !isVideo) {
    proxy.$notify({
      title: '対応形式はpng、jpg、mp4です。',
      customClass: 'danger',
      duration: 5000
    })
    // ファイル入力をリセット
    target.value = ''
    return
  }

  if (isImage && !isSupportedImageExtension(file.name)) {
    proxy.$notify({
      title: '対応形式はpng、jpg、mp4です。',
      customClass: 'danger',
      duration: 5000
    })
    target.value = ''
    return
  }

  // ファイルサイズチェック（画像8MB未満、動画25MB未満）
  const maxSize = isImage ? 8 * 1024 * 1024 : 25 * 1024 * 1024
  const sizeLabel = isImage ? '8MB' : '25MB'
  const fileTypeLabel = isImage ? '画像' : '動画'

  if (file.size >= maxSize) {
    proxy.$notify({
      title: `${fileTypeLabel}ファイルのサイズは${sizeLabel}未満にしてください。`,
      customClass: 'danger',
      duration: 5000
    })
    // ファイル入力をリセット
    target.value = ''
    return
  }

  // 画像/動画ともにAPIアップロードを実行し、mediaId を保存する
  try {
    const uploadResult = await store.uploadMedia(file)
    store.updateLottery({
      mediaId: uploadResult.mediaId,
      url: uploadResult.url,
      fileType: isImage ? 'image' : 'video',
      fileName: uploadResult.mediaOriginName || file.name
    })
  } catch (error) {
    TrackingService.reportError(
      error,
      {
        feature: 'instagram_instantwin',
        action: 'upload_lottery_media',
        screen: 'InstagramScenarioEditorDialog.StepLottery',
        prizeId: typeof store.prizeId === 'number' ? store.prizeId : undefined,
        node: 'lottery',
        fileType: isImage ? 'image' : 'video',
        fileSize: file.size
      },
      { mode: 'always' }
    )
    proxy.$notify({
      title: 'メディアのアップロードに失敗しました',
      customClass: 'danger',
      duration: 5000
    })
  }

  // ファイル入力をリセット
  target.value = ''
}

/**
 * メディア削除ハンドラ
 */
const handleMediaDelete = () => {
  // Blob URLの場合はメモリ解放
  if (lottery.value.url && lottery.value.url.startsWith('blob:')) {
    URL.revokeObjectURL(lottery.value.url)
  }
  store.clearLotteryMedia()
}

/**
 * 抽選中テキストの変更を監視してリアルタイムバリデーション
 */
watch(
  lottery,
  () => {
    store.validateStep3()
  },
  { deep: true }
)

return { __sfc: true,proxy, store, lottery, errors, getFileExtension, isSupportedImageExtension, isImageFile, getMediaFileName, handleMediaSelectClick, handleMediaFileChange, handleMediaDelete }
}

})